<template>
    <div class="bing-map">
      <div id="bing_map"></div>
    </div>
</template>
<script>
    let icon = require('../../static/images/lo.png');
    let star_icon = require('../../static/images/start_level.png');
    let svg = ['<svg xmlns="http://www.w3.org/2000/svg" width="80" height="40"><rect width="', 80, '" height="', 25, '" rx="2" ry="2" stroke="', '#0097FF', '" stroke-width="', 1, '" fill="', '#0097FF', '"/><polygon points="34,23,48,23,41,33" style="fill:#0097FF; stroke: #0097FF; stroke-width: 1"/></svg>'];
    export default {
      name: 'bing_map',
      props: ['long_lat'],
      data() {
          return {
            points: [],
            infobox: null
          }
      },
      computed: {
        lanType(){
          return +window.localStorage.getItem('lan_type');
        },
      },
      methods: {
        initMap () {
          setTimeout(() => {
            if( Microsoft ){
              if(this.long_lat.length){
              this.map = new Microsoft.Maps.Map('#bing_map', {
                zoom: 12,
                center: new Microsoft.Maps.Location(this.long_lat[0].latitude, this.long_lat[0].longitude),
              });
              this.infobox = new Microsoft.Maps.Infobox(this.map.getCenter(), {
                visible: false,
                showCloseButton: false,
                offset: new Microsoft.Maps.Point(0, -2),
              });

              this.infobox.setMap(this.map);
              this.addShape();
              // let pushpin = new Microsoft.Maps.Pushpin(this.map.getCenter(), { icon: icon,
              //   anchor: new Microsoft.Maps.Point(20, -60) });
              // this.map.entities.push(pushpin);
              }else{
                this.map = new Microsoft.Maps.Map('#bing_map', {
                zoom: 12
              });
                this.getCurrentPosition()
              }
            }
          }, 500)
        },
        // 生成球场坐标点
        addPoints() {
          for (var i = 0, longLatL = this.long_lat.length; i < longLatL; i++) {
            if (this.long_lat[i].latitude != '' && this.long_lat[i].longitude != '')
              this.points[i] = new Microsoft.Maps.Location(this.long_lat[i].latitude, this.long_lat[i].longitude);
          }
        },
        //  生成坐标点信息框
        addShape() {
          this.addPoints();
          for (var i = 0, longLatL = this.long_lat.length; i < longLatL; i++) {
            const item = this.long_lat[i];
            const hotelNameEn = this.lanType !== 4 && item.hotel_name !== item.hotel_name_en ? item.hotel_name_en : '';
            let $html = `
               <div class="hotel-info-box">
                  <div class="img-wrapper inline-block">
                    <img src="http://cdn.jalan.jp/jalan/images/pict2L/Y0/Y303560/Y303560045.jpg" alt="">
                  </div>
                  <div class="info-content inline-block">
                    <div class="hotel-name">${item.hotel_name}</div>
                    <div class="hotel_name_en">${hotelNameEn}</div>
                    <div class="star-wrapper">`;

              for (var j = 0, starNum = Number(item.star_rating); j < starNum; j++) {
                $html+= `<img src="${star_icon}" alt="">`
              }

              $html+=
              `
                    </div>
                  </div>`;

              if (item.score && item.score > 0) {
                $html+=
                  `
                  <div class="hotel-score-wrapper">
                     <div class="hotel-score">
                      <div class="score">${item.score}</div>
                    </div>`;
              }
              $html+=
                  `
                  </div>
               </div>
            `;

            var labelPrice = (item.min_price && item.min_price.price) ? ((item.tax_fee && item.tax_fee > 0) ? Number(item.min_price.price) + Number(item.tax_fee): Number(item.min_price.price)): '';
            var labelCurrency_code = (item.min_price && item.min_price.currency_code) ? item.min_price.currency_code : '';
            var labelText =  labelCurrency_code + ' ' + labelPrice ;
            var xIcon = svg.join('');
            var anchor = new Microsoft.Maps.Point(40, 15);
            /** 酒店详情页的地图弹窗显示默认图标 **/
            if (this.long_lat[0].hotel_detail) {
              xIcon = icon;
              anchor = new Microsoft.Maps.Point(15, 15);
              labelText = '';
            }
            let pushpin = new Microsoft.Maps.Pushpin(this.points[i], {
              icon: xIcon,
              text: labelText,
              anchor: anchor,
            });

            pushpin.metaData = {
              htmlContent: $html,
              hotel_id: item.hotel_id
            };

            Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', this.pushpinMouseOver);
            Microsoft.Maps.Events.addHandler(pushpin, 'mouseout', this.pushpinMouseOut);

            this.map.entities.push(pushpin);
          }
        },

        /** 获取用户当前位置经纬度 */
        getCurrentPosition(){
          navigator.geolocation.getCurrentPosition(function (position) {
            let loc = new Microsoft.Maps.Location(position.coords.latitude, position.coords.longitude);

            this.map.setView({center: loc});
          });
        },

        /** 移入地图图标回调函数 */
        pushpinMouseOver(e){
          const curInfoBox = e.target;
          var svg_red = ['<svg xmlns="http://www.w3.org/2000/svg" width="80" height="40"><rect width="', 80, '" height="', 25, '" rx="2" ry="2" stroke="', '#FD4700', '" stroke-width="', 1, '" fill="', '#FD4700', '"/><polygon points="34,23,48,23,41,33" style="fill:#FD4700; stroke: #FD4700; stroke-width: 1"/></svg>'];

          /** 不是酒店详情页 **/
          if (!this.long_lat[0].hotel_detail) {
            curInfoBox.setOptions({visible: true, icon: svg_red.join('')});
          }
          if (e.target.metaData) {
            this.infobox.setOptions({
              location: e.target.getLocation(),
              description: e.target.metaData.htmlContent,
              maxWidth: 1100,
              maxHeight: 600,
              visible: true
            });

            Microsoft.Maps.Events.addHandler(this.infobox, 'click', ev => {
              this.onLink(e.target.metaData.hotel_id);
            });
          }
        },

        /** 移出地图图标回调函数 */
        pushpinMouseOut(e){
          /** 不是酒店详情页 **/
          if (!this.long_lat[0].hotel_detail){
            var curInfoBox = e.target;
            curInfoBox.setOptions({visible: true, icon: svg.join('')});
          }

          if (e.target.metaData) {
            this.infobox.setOptions({
              visible: false
            });
          }
        },

        /** 路由到酒店详情 **/
        onLink(hotel_id) {
          var obj = {
            hotel_id: hotel_id
          };
          this.$emit('on-link', obj)
        }
      },
      mounted () {
        this.$nextTick(() => {
          if(this.long_lat.length){
            this.initMap();
          }else {
            setTimeout(() => {
              this.initMap();
            },1000)
          }
        })
      }
    }
</script>
<style lang="scss" scoped>
  .bing-map{
    width: 100%;
    height: 100%;
    background: #C8C7CC;
  }
</style>



// WEBPACK FOOTER //
// src/components/BingMap.vue